function toggleFilter() {
  let x = document.querySelector(".sq-filter-main");
  x.classList.toggle("opening");
}
function toggleClass() {
  let y = document.querySelector(".sq-filter-main");
  y.classList.remove("opening");
}
function removeClass() {
  let z = document.querySelector(".sq-filter-main");
  z.classList.remove("opening");
}

window.sq = window.sq || {};

window.sq.initSearch = (store) => {
  store.search();
};

window.sq.rangeFilter = (filters) => {
  const range = filters?.find(
    (x) => x.stFieldName === "price"
  );

  if(range) {
    range.items[0].displayLabel = "below - 25"
    range.items[5].displayLabel = "300 - Above"
  }
  return filters;
}



window.sq.showFilter = function () {
  if( document.querySelector(".sparq-row-base")) document.querySelector(".sparq-row-base").style.visibility = null;
  if(document.querySelector(".sq-filter-main")) document.querySelector(".sq-filter-main").style.visibility = null;
  if(document.querySelector(".sq-filter-header-title")) document.querySelector(".sq-filter-header-title").style.visibility = null;
};
setTimeout(() => {
  window.sq.showFilter();
  if(document.querySelector(".sparq-filter-btn")) document.querySelector(".sparq-filter-btn").addEventListener("click", () => {
    toggleFilter();
  });
  if(document.querySelector("#overlay")) document.querySelector("#overlay").addEventListener("click", () => {
    removeClass();
  });
  if(document.querySelector(".sq-filter-bottom")) document.querySelector(".sq-filter-bottom").addEventListener("click", () => {
    removeClass();
  });
  if(document.querySelector(".sq-cross")) document.querySelector(".sq-cross").addEventListener("click", () => {
    removeClass();
  });
}, 1000);


// (function (XHR) {
//   "use strict";

//   var open = XHR.prototype.open;
//   var send = XHR.prototype.send;

//   XHR.prototype.open = function (method, url, async, user, pass) {
//     this._url = url;
//     open.call(this, method, url, async, user, pass);
//   };

//   XHR.prototype.send = function (data) {
//     var self = this;
//     var url = this._url;
//     if (
//       url &&
//       url.toLowerCase() ===
//         "https://awdugyic16lq7p5xzcpszpwk-fast.searchtap.net/v2".toLowerCase()
//     ) {
//       const body = JSON.parse(data);

//       let sorting = body.sort;

//       if (sorting.length == 0) {
//         body.sort.push("bestSellingScore");
//       }

//       if (body.sort.length > 1) {
//         sorting = sorting.filter((x) => x !== "bestSellingScore");
//         body.sort = sorting;
//       }

//       data = JSON.stringify(body);
//     }
//     send.call(this, data);
//   };
// })(XMLHttpRequest);
(function (XHR) {
  "use strict";

  var open = XHR.prototype.open;
  var send = XHR.prototype.send;

  XHR.prototype.open = function (method, url, async, user, pass) {
    this._url = url;
    open.call(this, method, url, async, user, pass);
  };

  XHR.prototype.send = function (data) {
    var self = this;
    var url = this._url;
    let location = window.location.href;
    let collectionHandle = location.split("/collections/")[1];
    if (
      url &&
      url.toLowerCase() ===
      "https://awdugyic16lq7p5xzcpszpwk-fast.searchtap.net/v2".toLowerCase()
    ) {
      const body = JSON.parse(data);

      let sorting = body.sort;
      
      const str = body.filter;
      const match = str.match(/collectionHandles\s*=\s*"([^"]+)"/);
      const collectionHandle = match ? match[1] : null;
      
      if(sorting.length == 0 && !location.includes("/search") && !location.includes("/all")) {
        body.sort.push(`sortOrderFor_${collectionHandle.replaceAll("-","_")}`)
      }

       if (body.sort.length > 1 && !location.includes("/search") && !location.includes("/all")) {
        sorting = sorting.filter((x) => x !== `sortOrderFor_${collectionHandle.replaceAll("-","_")}`);
        body.sort = sorting;
      }

      data = JSON.stringify(body);
    }
    send.call(this, data);
  };
})(XMLHttpRequest);